export default Object.freeze({
  EFH: {text: 'Einfamilienhaus', value: 'EFH'},
  EFH_EW: {text: 'Einfamilienhaus mit Einliegerwohnung', value: 'EFH_EW'},
  ZFH: {text: 'Zweifamilienhaus', value: 'ZFH'},
  ETW: {text: 'Eigentumswohnung', value: 'ETW'},
  MFH: {text: 'Mehrfamilienhaus', value: 'MFH'},
  WGH: {text: 'Wohn- und Geschäftshaus', value: 'WGH'},

  values: function () {
    return [this.EFH.value, this.EFH_EW.value, this.ZFH.value, this.ETW.value, this.MFH.value, this.WGH.value];
  },

  objects: function () {
    return [this.EFH, this.EFH_EW, this.ZFH, this.ETW, this.MFH, this.WGH];
  },
});